import { CountryDTO } from '@/core/api/dtos/response/misc/country'
import { Country } from '@/core/api/entities/misc/country'

export class CountryMapper {
	static toEntity = (dto: CountryDTO): Country => {
		return Country.create(dto)
	}

	static toEntityList = (dtos: CountryDTO[]): Country[] => {
		return dtos.map(this.toEntity)
	}
}
